import { useState } from 'react';
import api from '../api/axios';
import { generateTempPassword } from '../utils/tempPassword';
import '../styles/userspage.css';

// Admin sets a new temporary password for a user (e.g. they forgot theirs).
// The user is forced to change it again on their next sign-in.
export default function ResetUserPasswordModal({ user, onClose }) {
  const [password, setPassword] = useState(() => generateTempPassword());
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) return setError('Temporary password must be at least 8 characters.');

    setBusy(true);
    try {
      await api.post(`/users/${user._id}/reset-password`, { password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Could not reset the password.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-bg" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <form className="modal" onSubmit={handleSubmit} noValidate>
        <h2>Reset password for {user.name}</h2>
        {error && <div className="login-err">{error}</div>}

        {done ? (
          <>
            <div className="hpu-success">
              Password reset. Share the new temporary password with {user.name}. They'll set their own on next sign-in.
            </div>
            <div className="hpu-temp-password">{password}</div>
            <small className="hpu-hint">This password won't be shown again. Copy it now.</small>
            <div className="hpu-modal-actions">
              <button type="button" className="btn btn-outline" onClick={() => navigator.clipboard?.writeText(password)}>
                Copy password
              </button>
              <button type="button" className="btn btn-primary" onClick={onClose}>Done</button>
            </div>
          </>
        ) : (
          <>
            <div className="fg">
              <label>New temporary password</label>
              <div className="hpu-password-row">
                <input value={password} onChange={(e) => setPassword(e.target.value)} />
                <button type="button" className="btn btn-outline btn-sm" onClick={() => setPassword(generateTempPassword())}>
                  New
                </button>
              </div>
              <small className="hpu-hint">Their current password stops working immediately.</small>
            </div>
            <div className="hpu-modal-actions">
              <button type="button" className="btn btn-outline" onClick={onClose} disabled={busy}>Cancel</button>
              <button type="submit" className="btn btn-primary" disabled={busy}>
                {busy ? 'Resetting…' : 'Reset password'}
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
